import $ from "jquery";

export const animateButtonsJQ = ($buttons) => {
  $buttons.each(function(index, element){
    $(element).addClass("animated fadeInUp");
    setTimeout(function () {
      $(element).addClass("button--finished-transition");
    }, 50 * index)
  })
};

export const hideButtonsJQ = ($buttons) => {
  $buttons.each(function(index, element){
    $(element).removeClass("animated fadeInUp button--finished-transition");
  })
};

export const animateButtons = (buttons) => {
  buttons.forEach((element, index) => {
    if (element) {
      element.classList.add("animated", "fadeInUp");
      setTimeout(() => {
        element.classList.add("button--finished-transition");
      }, 50 * index);
    }
  });
};

export const hideButtons = (buttons) => {
  buttons.forEach((element) => {
    if (element) {
      element.classList.remove("animated", "fadeInUp", "button--finished-transition");
    }
  });
};
